__webpack_require__.p = "/vrtour/komnidismuseum/_next/";